import { IWorkflowRegistry, IWorkflowRepository } from "../../../domain/workflow";
import { WorkflowRepository } from ".";

export class WorkflowRegistry implements IWorkflowRegistry {
  constructor(private _getToken: () => string) {
  }

  getWorkflowRepository(): IWorkflowRepository {
    return new WorkflowRepository(this._getToken);
  }
}
